export default __webpack_public_path__ + "static/media/profile.066f7e45.png";